export const disposeColors = (type = "1") => {
  if (type === "1") {
    return {
      colorList: [
        "#227EFF",
        "#00CA76",
        "#FA9237",
        "#F7C148",
        "#09B9B6",
        "#FF5660",
        "#8658FF",
        "#8DD36F",
      ],
      imgColorsList: [
        "#DAE9FF",
        "#D6FAEC",
        "#FFEDDE",
        "#FDEABE",
        "#B1F1F0",
        "#FBDCDE",
        "#EEE7FF",
        "#DAF0D1",
      ],
    };
  } else {
    return {
      colorList: [
        "#00CA76",
        "#227EFF",
        "#FA9237",
        "#F7C148",
        "#09B9B6",
        "#FF5660",
        "#8658FF",
        "#8DD36F",
      ],
      imgColorsList: [
        "#D6FAEC",
        "#DAE9FF",
        "#FFEDDE",
        "#FDEABE",
        "#B1F1F0",
        "#FBDCDE",
        "#EEE7FF",
        "#DAF0D1",
      ],
    };
  }
};
